import React from 'react';
import {RenderStoryBackgroundProps} from '../../types';
import './RenderStoryBackground.css';

const RenderStoryBackground: React.FC<RenderStoryBackgroundProps> = ({
  useBackgroundImage,
  children,
  backgrounduri,
}) => {
  const style: React.CSSProperties = useBackgroundImage && backgrounduri
    ? {
        backgroundImage: `url(${backgrounduri})`,
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    : {};

  return (
    <div className="web-story-background" style={style}>
      {children}
    </div>
  );
};

export default RenderStoryBackground;
